import React, { ChangeEvent, useCallback } from 'react';
import { Control, UseFormSetValue, UseFormWatch } from 'react-hook-form';
import { Grid } from '@mui/material';
import { EuroOutlined } from '@mui/icons-material';
import { DiscountTypes } from 'api';
import { FormCard, FormInput } from 'components';
import DISCOUNTS from 'constants/discounts';

interface Props {
  control: Control<DiscountTypes.ItemCreateParams> | undefined;
  watch: UseFormWatch<DiscountTypes.ItemCreateParams>;
  setValue: UseFormSetValue<DiscountTypes.ItemCreateParams>;
}

const MinRequirementsBlock = (props: Props): JSX.Element | null => {
  const { control, watch, setValue } = props;

  const minimumRequirements = watch('minimum_requirements');

  const handleMinRequirementsChange = useCallback(
    (
      event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
      onChange: (value: string | string[] | undefined) => void,
    ) => {
      setValue('minimum_value', 0);

      onChange(event.target.value);
    },
    [setValue],
  );

  return (
    <FormCard title="Minimum purchase requirements">
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <FormInput
            control={control}
            name="minimum_requirements"
            inputType="radio"
            label="Minimum requirements"
            tooltip={`After changing this field "Min value" field will be reset`}
            options={DISCOUNTS.MINIMUM_REQUIREMENTS_OPTIONS}
            onChange={handleMinRequirementsChange}
            rules={{ required: true }}
          />
        </Grid>
        <Grid item xs={12}>
          {minimumRequirements !==
            DiscountTypes.MinimumRequirementsEnum.None && (
            <FormInput
              control={control}
              name="minimum_value"
              inputType="number"
              label={
                minimumRequirements ===
                DiscountTypes.MinimumRequirementsEnum.MinimumPurchaseAmount
                  ? DiscountTypes.MinimumRequirementsEnum.MinimumPurchaseAmount
                  : DiscountTypes.MinimumRequirementsEnum.MinimumQuantity
              }
              InputProps={{
                endAdornment:
                  minimumRequirements ===
                  DiscountTypes.MinimumRequirementsEnum
                    .MinimumPurchaseAmount ? (
                    <EuroOutlined />
                  ) : undefined,
              }}
              rules={{
                required: true,
                min: 1,
                onBlur: (e) =>
                  setValue('minimum_value', +(+e.target.value).toFixed(2)),
              }}
            />
          )}
        </Grid>
      </Grid>
    </FormCard>
  );
};

export default MinRequirementsBlock;
